import React, { useState, useContext, useEffect } from "react";
import { ProfielContext } from "./profiel-context";
import { API } from 'aws-amplify';
import { getResponseData } from '../utils/apiHelpers';

export const NotificationsContext = React.createContext({
  notifications: [],
  setNotifications: () => { },
  reload: false,
  setReload: () => { },
  refreshpage: false,
  setRefreshpage: () => { },
});

const NotificationsContextProvider = (props) => {
  const profielContext = useContext(ProfielContext);

  const [notificationsCount, setNotificationsCount] = useState(0);
  const [reload, setReload] = useState(0);
  const [refreshpage, setRefreshpage] = useState(true);

  useEffect(() => {
    if (refreshpage & profielContext.profiel) {
      setRefreshpage(false);
      let apiName = "AWSApiGateway";
      let path = `/gebruikers/uitnodigings?gebruiker=${profielContext.profiel.epos ? profielContext.profiel.epos : ""
        },${profielContext.profiel.selfoon
          ? profielContext.profiel.selfoon.replace(/-|\+|\s/g, "")
          : ""
        }`;
      API.get(apiName, path, { response: true })
        .then((response) => {
          console.log(response);
          if (response.status === 204) {
            setNotificationsCount(0);
          } else {
            setNotificationsCount(getResponseData(response, []).length);
          }
          setReload(reload + 1);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [refreshpage, profielContext.profiel]);

  return (
    <NotificationsContext.Provider
      value={{
        addNotifications: (count) =>
          setNotificationsCount(notificationsCount + count),
        removeNotifications: (count) =>
          setNotificationsCount(notificationsCount - count),
        notificationsCount: notificationsCount,
        reload: reload,
        stelreload: setReload,
        refreshpage: refreshpage,
        stelrefresh: setRefreshpage,
      }}
    >
      {props.children}
    </NotificationsContext.Provider>
  );
};

export default NotificationsContextProvider;
